import styled from '@emotion/styled'
import { SvgIcon, SvgIconProps } from '@mui/material'

const StyledPath = styled.path`
  fill: #1aaf64;
`

const CorrectIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 22.5 22.5">
    <StyledPath d="M11.25 22.5A11.25 11.25 0 1 1 22.5 11.25 11.25 11.25 0 0 1 11.25 22.5zm0-20.625a9.375 9.375 0 1 0 9.375 9.375 9.375 9.375 0 0 0-9.375-9.375z" />
    <StyledPath
      d="M9.691 16.379a.937.937 0 0 1-.666-.272l-3.75-3.75A.937.937 0 0 1 6.6 11.035l3.094 3.084 6.834-6.834a.937.937 0 0 1 1.322 1.322l-7.5 7.5a.937.937 0 0 1-.659.272z"
      transform="translate(-.316 -.441)"
    />
  </SvgIcon>
)

export default CorrectIcon
